
import {
  KITCHEN_SINK,
  DOUBLE_KITCHEN_SINK,
  POT_SINK,
  DOUBLE_POT_SINK,
  HAND_BASIN,
  WOK_BURNERS,
  COMBI_OVENS,
  CONNECTING_EXISTING_GREASE_ARRESTOR,
  CONNECTING_NEW_GREASE_ARRESTOR,
  ADDITIONAL_FITOUT_OR_PLUMBING_WORK,
  SELECT_OPTIONS,
  EXISTING_ARRESTOR_BARCODE,
  EXISTING_ARRESTOR_LOCATION,
  EXISTING_ARRESTOR_SHARED,
  EXISTING_ARRESTOR_SIZE,
  NEW_ARRESTOR_INSTALL_DATE,
  NEW_ARRESTOR_LICENSED_PLUMBER_CONTACT,
  NEW_ARRESTOR_LICENSED_PLUMBER_NAME,
  NEW_ARRESTOR_MAKE_MODEL,
  NEW_ARRESTOR_SIZE
} from "../../../Constants";
import Attachments from "../Attachments/index";
import { Control, DeepMap, FieldError, UseFormRegister, UseFormUnregister } from "react-hook-form";
import RadioGroup from "../../../Components/tw/RadioGroup";
import Select from "../../../Components/Select";
import Contacts from "../../../Components/Contacts";
import Input from "../../../Components/Input";
import DateSelector from "../../../Components/DateSelector";
import { useStateMachine } from "little-state-machine";

interface KitchenFixturesInterface {
  uploadError: string;
  control: Control<Record<string, any>>;
  errors: DeepMap<Record<string, any>, FieldError>
  register: UseFormRegister<any>;
  unregister: UseFormUnregister<any>;
  watch: Function
}
const KitchenFixtures = ({
  uploadError,
  control,
  errors,
  register,
  unregister,
  watch,
}: KitchenFixturesInterface) => {
  const { state } = useStateMachine();
  const connecting_new = watch(CONNECTING_NEW_GREASE_ARRESTOR, state?.data[CONNECTING_NEW_GREASE_ARRESTOR])
  const connecting_existing = watch(CONNECTING_EXISTING_GREASE_ARRESTOR, state?.data[CONNECTING_EXISTING_GREASE_ARRESTOR])
  const is_shared = watch(EXISTING_ARRESTOR_SHARED, state?.data[EXISTING_ARRESTOR_SHARED]);
  const additional_work = watch(ADDITIONAL_FITOUT_OR_PLUMBING_WORK, state?.data[ADDITIONAL_FITOUT_OR_PLUMBING_WORK])

  return (
    <section>
      <h2>
        Kitchen fixtures
      </h2>
      <h3>Enter the number of installed/proposed kitchen fixtures below</h3>
      <Select
        short={true}
        defaultValue={state?.data[KITCHEN_SINK]}
        errorMessage={errors[KITCHEN_SINK]?.message}
        id={KITCHEN_SINK}
        name={KITCHEN_SINK}
        options={SELECT_OPTIONS}
        register={register}
        registerOptions={{ required: "Please select" }}
        label="Kitchen sink"
      />

      <Select
        short={true}
        defaultValue={state?.data[DOUBLE_KITCHEN_SINK]}
        errorMessage={errors[DOUBLE_KITCHEN_SINK]?.message}
        id={DOUBLE_KITCHEN_SINK}
        name={DOUBLE_KITCHEN_SINK}
        options={SELECT_OPTIONS}
        register={register}
        registerOptions={{ required: "Please select" }}
        label="Double kitchen sink"
      />


      <Select
        short={true}
        defaultValue={state?.data[POT_SINK]}
        errorMessage={errors[POT_SINK]?.message}
        id={POT_SINK}
        name={POT_SINK}
        options={SELECT_OPTIONS}
        register={register}
        registerOptions={{ required: "Please select" }}
        label="Pot sink"
      />


      <Select
        short={true}
        defaultValue={state?.data[DOUBLE_POT_SINK]}
        errorMessage={errors[DOUBLE_POT_SINK]?.message}
        id={DOUBLE_POT_SINK}
        name={DOUBLE_POT_SINK}
        options={SELECT_OPTIONS}
        register={register}
        registerOptions={{ required: "Please select" }}
        label="Double pot sink"
      />


      <Select
        short={true}
        defaultValue={state?.data[HAND_BASIN]}
        errorMessage={errors[HAND_BASIN]?.message}
        id={HAND_BASIN}
        name={HAND_BASIN}
        options={SELECT_OPTIONS}
        register={register}
        registerOptions={{ required: "Please select" }}
        label="Hand basin"
      />
      <Select
        short={true}
        defaultValue={state?.data[WOK_BURNERS]}
        errorMessage={errors[WOK_BURNERS]?.message}
        id={WOK_BURNERS}
        name={WOK_BURNERS}
        options={SELECT_OPTIONS}
        register={register}
        registerOptions={{ required: "Please select" }}
        label="Wok burners"
      />

      <Select
        short={true}
        defaultValue={state?.data[COMBI_OVENS]}
        errorMessage={errors[COMBI_OVENS]?.message}
        id={COMBI_OVENS}
        name={COMBI_OVENS}
        options={SELECT_OPTIONS}
        register={register}
        registerOptions={{ required: "Please select" }}
        label="Combi ovens"
      />

      <RadioGroup
        registerOptions={{
          required: "Please make a selection"
        }}
        register={register}
        unregister={unregister}
        name={CONNECTING_EXISTING_GREASE_ARRESTOR}
        legend="Are you connecting to an existing grease arrestor? "
        errorMessage={errors[CONNECTING_EXISTING_GREASE_ARRESTOR]}
        radios={[
          { value: "Yes" },
          { value: "No" },
        ]}
      />
      {
        connecting_existing === "Yes" && (
          <>
            <Input
              defaultValue={state?.data[EXISTING_ARRESTOR_BARCODE]}
              name={EXISTING_ARRESTOR_BARCODE}
              id={EXISTING_ARRESTOR_BARCODE}
              label="If you know, please enter existing Water Corporation barcode number for the grease arrestor"
              type="text"
              short={true}
              assistiveText="The barcode is the six digits number on a metal plate located near your grease arrestor"
              register={register}
            />
            <Input
              defaultValue={state?.data[EXISTING_ARRESTOR_LOCATION]}
              name={EXISTING_ARRESTOR_LOCATION}
              id={EXISTING_ARRESTOR_LOCATION}
              label="Location of grease arrestor "
              type="text"
              register={register}
              registerOptions={{
                required: "Please enter location"
              }}
              errorMessage={errors[EXISTING_ARRESTOR_LOCATION]?.message}
            />
            <Input
              defaultValue={state?.data[EXISTING_ARRESTOR_SIZE]}
              name={EXISTING_ARRESTOR_SIZE}
              id={EXISTING_ARRESTOR_SIZE}
              label="Size (in litres) (optional)"
              type="number"
              short={true}
              register={register}
            />
            <RadioGroup
              name={EXISTING_ARRESTOR_SHARED}
              legend="Is the grease arrestor shared with any other businesses? "
              registerOptions={{
                required: "Please make a selection"
              }}
              register={register}
              unregister={unregister}
              radios={[
                { value: "Yes" },
                { value: "No" },
              ]}
              errorMessage={errors[EXISTING_ARRESTOR_SHARED]}
            />
            {is_shared === "Yes" && <Contacts control={control} register={register} />}
          </>
        )
      }
      <RadioGroup
        name={CONNECTING_NEW_GREASE_ARRESTOR}
        legend="Will you be installing a new grease arrestor? "
        errorMessage={errors[CONNECTING_NEW_GREASE_ARRESTOR]}
        registerOptions={{
          required: "Please make a selection"
        }}
        register={register}
        unregister={unregister}
        radios={[
          { value: "Yes" },
          { value: "No" },
        ]}
      />
      {(connecting_new === "Yes") && (
        <><Input
          defaultValue={state?.data[NEW_ARRESTOR_SIZE]}
          name={NEW_ARRESTOR_SIZE}
          id={NEW_ARRESTOR_SIZE}
          label="Size (in litres) "
          type="number"
          short={true}
          register={register}
          registerOptions={{
            required: "Please enter size"
          }}
          errorMessage={errors[NEW_ARRESTOR_SIZE]?.message} />

          <Input
            defaultValue={state?.data[NEW_ARRESTOR_MAKE_MODEL]}
            name={NEW_ARRESTOR_MAKE_MODEL}
            id={NEW_ARRESTOR_MAKE_MODEL}
            label="Make/model (optional)"
            type="text"
            register={register} />

          <DateSelector
            defaultValue={state?.data[NEW_ARRESTOR_INSTALL_DATE]}
            id={NEW_ARRESTOR_INSTALL_DATE}
            name={NEW_ARRESTOR_INSTALL_DATE}
            label="Planned installation date"
            control={control}
            required={true}
            errorMessage={errors[NEW_ARRESTOR_INSTALL_DATE]}
          />

          <Input
            defaultValue={state?.data[NEW_ARRESTOR_LICENSED_PLUMBER_NAME]}
            name={NEW_ARRESTOR_LICENSED_PLUMBER_NAME}
            id={NEW_ARRESTOR_LICENSED_PLUMBER_NAME}
            label="Name of licensed plumber (optional)"
            short={true}
            type="text"
            register={register} />
          <Input
            defaultValue={state?.data[NEW_ARRESTOR_LICENSED_PLUMBER_CONTACT]}
            name={NEW_ARRESTOR_LICENSED_PLUMBER_CONTACT}
            id={NEW_ARRESTOR_LICENSED_PLUMBER_CONTACT}
            label="Contact number of the licensed plumber (optional)"
            type="text"
            register={register} />
        </>
      )
      }
      {
        (connecting_new === "No") && (
          <p>
            <strong>
              You have indicated that you are not connecting to or installing a new
              grease arrestor. Please note that Water Corporation will provide the
              final determination of required pre-treatment (such as a grease
              arrestor) during the trade waste application assessment process
            </strong>
          </p>
        )}
      <RadioGroup
        name={ADDITIONAL_FITOUT_OR_PLUMBING_WORK}
        legend="Are you doing any fitouts or additional plumbing work? "
        errorMessage={errors[ADDITIONAL_FITOUT_OR_PLUMBING_WORK]}
        registerOptions={{
          required: "Please make a selection"
        }}
        register={register}
        unregister={unregister}
        radios={[
          { value: "Yes" },
          { value: "No" },
        ]}
      />
      <Attachments isRequired={additional_work === "Yes"} uploadError={uploadError} />
    </section >
  );
};

export default KitchenFixtures;
